export const appsAppGroupIdChartsDailyRevenueByPurchaseNames =
  "/apps/:app_group_id/charts/daily_revenue_by_purchase_names";
